import mountainWaveAmberImg from "../../../../images/contents/map/sigmet/mountain_wave_amber.png";
import mountainWaveRedImg from "../../../../images/contents/map/sigmet/mountain_wave_red.png";
import mountainWaveSectorAmberImg from "../../../../images/contents/map/sigmet/mountain_wave_sector_amber.png";
import mountainWaveSectorRedImg from "../../../../images/contents/map/sigmet/mountain_wave_sector_red.png";
import radioactivityImg from "../../../../images/contents/map/sigmet/radioactivity.png";
import triangleAmberImg from "../../../../images/contents/map/sigmet/triangle_amber.png";
import triangleRedImg from "../../../../images/contents/map/sigmet/triangle_red.png";
import typhoonAmberImg from "../../../../images/contents/map/sigmet/typhoon_amber.png";
import typhoonRedImg from "../../../../images/contents/map/sigmet/typhoon_red.png";

export const configSigmetDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "%wrap_url%/WX_ALL_SIGMET_Latest/latest.json",
    "update_interval": 60,
    "retain": true,
    "cache": false,
    "cache_busting": true
  }
};

export const configSigmetLayer = {
  "Name": "SIGMET",
  "Renderer": "GeoJSON",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "MountainWave_OBS"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 32,
            "height": 16,
            "offset_x": -16,
            "offset_y": -8,
            "url": mountainWaveRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "MountainWave_undefined"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 32,
            "height": 16,
            "offset_x": -16,
            "offset_y": -8,
            "url": mountainWaveRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "MountainWave_FCST"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 32,
            "height": 16,
            "offset_x": -16,
            "offset_y": -8,
            "url": mountainWaveAmberImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Typhoon_OBS"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 32,
            "offset_x": -8,
            "offset_y": -16,
            "url": typhoonRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Typhoon_undefined"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 32,
            "offset_x": -8,
            "offset_y": -16,
            "url": typhoonRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Typhoon_FCST"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 32,
            "offset_x": -8,
            "offset_y": -16,
            "url": typhoonAmberImg
          }
        }
      },

      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Point_OBS"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 16,
            "offset_x": -8,
            "offset_y": -8,
            "url": triangleRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Point_undefined"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 16,
            "offset_x": -8,
            "offset_y": -8,
            "url": triangleRedImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wrap_elm_type",
          "value": "Point_FCST"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 16,
            "height": 16,
            "offset_x": -8,
            "offset_y": -8,
            "url": triangleAmberImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "elm_type",
          "value": "RadioAct"
        },
        "style": {
          "default": {
            "type": "image",
            "width": 30,
            "height": 30,
            "offset_x": -15,
            "offset_y": -15,
            "url": radioactivityImg
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TS_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TS_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TS_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TSGR_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TSGR_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TSGR_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "CB_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "CB_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "CB_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,0,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TURB_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TURB_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(134,113,90,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "TURB_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "DS_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "DS_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(134,113,90,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "DS_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "SS_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "SS_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(134,113,90,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "SS_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "MTW_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "MTW_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgba(134,113,90,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "MTW_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgba(136,100,0,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "ICE_OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgb(91,91,136,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "ICE_FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "fill_color": "rgb(91,91,136,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "sigmet_kind",
          "value": "ICE_undefined"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "fill_color": "rgb(91,91,136,0.3)",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "data_type",
          "value": "OBS"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "line_width": 2
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "data_type",
          "value": "FCST"
        },
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#F3D51A",
            "line_width": 2
          }
        }
      },
      {
        "style": {
          "default": {
            "type": "Polygon",
            "point_size": 13,
            "point_color": "#ffff22",
            "line_color": "#ff0000",
            "line_width": 2
          }
        }
      }
    ],
    "tooltip": {
      "text_color": "red",
      "round_corner": 0
    }
  }
};

export const configSigmetAddingLayer = {
  "default": {
    "sigmetTypeText": {
      "fontSize": 13,
      "fillStyle": "#006b00",
      "align": "center",
      "offsetY": 0
    },
    "sigmetTypePoint": {
      "fontSize": 13,
      "fillStyle": "#006b00",
      "align": "center",
      "offsetY": 19
    },
    "sigmetTypeTC_OBS": {
      "width": 16,
      "height": 32,
      "offsetX": -8,
      "offsetY": -16,
      "image": typhoonRedImg,
      "adjustOffsetAltitude": -6
    },
    "sigmetTypeTC_FCST": {
      "width": 16,
      "height": 32,
      "offsetX": -8,
      "offsetY": -16,
      "image": typhoonAmberImg,
      "adjustOffsetAltitude": -6
    },
    "sigmetTypeMTW_OBS": {
      "width": 32,
      "height": 16,
      "offsetX": -16,
      "offsetY": -8,
      "image": mountainWaveRedImg,
      "adjustOffsetAltitude": 2
    },
    "sigmetTypeMTW_FCST": {
      "width": 32,
      "height": 16,
      "offsetX": -16,
      "offsetY": -8,
      "image": mountainWaveAmberImg,
      "adjustOffsetAltitude": 2
    },
    "sigmetTypeRDOACT": {
      "width": 30,
      "height": 30,
      "offsetX": -15,
      "offsetY": -15,
      "image": radioactivityImg
    },
    "altitude": {
      "fontSize": 13,
      "fillStyle": "#006b00",
      "align": "center"
    },
    "MountainWaveSector_OBS": {
      "width": 64,
      "height": 50,
      "offsetX": -32,
      "offsetY": -25,
      "image": mountainWaveSectorRedImg
    },
    "MountainWaveSector_undefined": {
      "width": 64,
      "height": 50,
      "offsetX": -32,
      "offsetY": -25,
      "image": mountainWaveSectorRedImg
    },
    "MountainWaveSector_FCST": {
      "width": 64,
      "height": 50,
      "offsetX": -32,
      "offsetY": -25,
      "image": mountainWaveSectorAmberImg
    }
  }
};
